var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.435,
    height: 32,
    viewBox: "0 0 32.435 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-905.565 -845)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32,
    transform: "translate(906 845)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M197.232,79.54a8.428,8.428,0,0,1-2.875-2.079c-.062-.066-.123-.136-.183-.209-.06.071-.12.141-.182.209a8.387,8.387,0,0,1-2.864,2.079,9.843,9.843,0,0,1-7.647,0,8.442,8.442,0,0,1-2.876-2.079,9.184,9.184,0,0,1-1.81-3.023,10.418,10.418,0,0,1-.629-3.608,9.866,9.866,0,0,1,2.451-6.674,8.459,8.459,0,0,1,2.878-2.074,9.82,9.82,0,0,1,7.619,0,8.413,8.413,0,0,1,2.866,2.074c.066.074.131.148.2.223.066-.075.133-.149.2-.223a8.463,8.463,0,0,1,2.872-2.074,9.823,9.823,0,0,1,7.619,0,8.413,8.413,0,0,1,2.866,2.074,10.328,10.328,0,0,1,.012,13.305,8.387,8.387,0,0,1-2.864,2.079,9.84,9.84,0,0,1-7.647,0Zm-.727-8.709c0,3.132,1.957,5.493,4.553,5.493s4.554-2.377,4.554-5.528c0-3.132-1.958-5.493-4.554-5.493s-4.553,2.376-4.553,5.527Zm-13.752,0c0,3.132,1.958,5.493,4.554,5.493s4.554-2.377,4.554-5.528c0-3.132-1.958-5.493-4.554-5.493s-4.554,2.376-4.554,5.527Zm16.57-.018a1.72,1.72,0,1,1,1.719,1.79A1.754,1.754,0,0,1,199.323,70.813Zm-13.757,0a1.72,1.72,0,1,1,1.719,1.79A1.755,1.755,0,0,1,185.566,70.813Z",
    transform: "translate(727.401 790.187)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.2174bbeee3dbcbddc371eed623a1c388.svg";
export { ForwardRef as ReactComponent };